import type { PageTemplateProps } from '@pega/cosmos-react-core';

export const getPath = (
  showBreadcrumbs?: boolean,
  pathData?: string
): PageTemplateProps['path'] => {
  if (showBreadcrumbs) {
    return pathData
      ? pathData.split(',').map((item: any) => {
          return { id: item, primary: item, href: `#${item.replaceAll(' ', '-')}` };
        })
      : [];
  }
};
